import { render } from "./Vizija.vue?vue&type=template&id=0781e3e4&scoped=true"
import script from "./Vizija.vue?vue&type=script&lang=js"
export * from "./Vizija.vue?vue&type=script&lang=js"

import "./Vizija.vue?vue&type=style&index=0&id=0781e3e4&scoped=true&lang=css"

import exportComponent from "/Users/edvinasjuck/PhpstormProjects/arunvilkasa.lt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0781e3e4"]])

export default __exports__